import React from 'react';
import { FiCpu, FiMessageSquare, FiSearch } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const AEOSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-orange-600 font-bold tracking-wide uppercase text-sm mb-3">The Future of Search</h2>
            <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
              What is Answer Engine Optimization (AEO)?
            </h3>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed">
              Traditional SEO ranks links. <strong>AEO ranks answers.</strong> With the rise of AI search tools like ChatGPT, Google Gemini, and Perplexity, your business needs to be the <em>direct answer</em> to your customers' questions.
            </p>
            
            <div className="space-y-6">
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center text-blue-600">
                  <SafeIcon icon={FiCpu} className="text-xl" />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900 text-lg">Optimized for AI Indexing</h4>
                  <p className="text-slate-600">We structure your data so AI models can easily "read" and recommend your business.</p>
                </div>
              </div>
              
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-purple-50 rounded-lg flex items-center justify-center text-purple-600">
                  <SafeIcon icon={FiMessageSquare} className="text-xl" />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900 text-lg">Conversational Keywords</h4>
                  <p className="text-slate-600">Targeting natural language questions like "Who is the best plumber in Calgary?"</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-tr from-orange-100 to-blue-50 rounded-2xl transform rotate-3"></div>
            <div className="relative bg-white border border-gray-100 rounded-2xl shadow-xl p-8">
              <div className="flex items-center gap-3 mb-6 border-b border-gray-100 pb-4">
                <div className="w-3 h-3 rounded-full bg-red-400"></div>
                <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                <div className="w-3 h-3 rounded-full bg-green-400"></div>
                <span className="ml-auto text-xs text-slate-400">AI Search Simulation</span>
              </div>
              
              <div className="space-y-4">
                <div className="bg-slate-50 p-4 rounded-lg rounded-tl-none">
                  <p className="text-slate-700 font-medium">User: "Find me a reliable roofing company in Edmonton."</p>
                </div>
                <div className="bg-blue-600 text-white p-4 rounded-lg rounded-tr-none shadow-lg">
                  <p className="font-medium mb-2">AI Response:</p>
                  <p className="text-blue-50">Based on recent reviews and service capabilities, <strong>[Your Company Name]</strong> is highly recommended in Edmonton. They offer 24/7 emergency repair and have a 4.9-star rating.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AEOSection;